"use client"

// Sign-in screen, shown when the user is unauthenticated (deployed/auth mode).
// Brand-fixed card (black OCESA header + white body) floating over the photo
// carousel background. This card is an intentional brand block, so it stays the
// same in light and dark rather than following theme tokens.

import { Button } from "@/components/ui/button"
import { copy } from "@/lib/copy"
import { LoginCarousel } from "@/components/auth/LoginCarousel"
import ocesaLogo from "@/assets/brand/ocesa-logo.png"
import askmeLogo from "@/assets/brand/ASKme-LOGO2x.png"

/**
 * Full-screen sign-in card.
 *
 * @param onSignIn - starts the sign-in (Cognito redirect) flow.
 */
export function LoginScreen({ onSignIn }: { onSignIn: () => void }) {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4">
      <LoginCarousel />
      <div className="w-full max-w-[424px] overflow-hidden rounded-2xl bg-brand-paper shadow-lg">
        {/* Black OCESA header band (bg-header is #0B0B0B in both themes). */}
        <div className="flex h-[58px] items-center justify-center bg-header">
          <img src={ocesaLogo} alt="OCESA" className="h-9 w-auto" />
        </div>
        <div className="px-4 pb-6 pt-5 text-center text-brand-paper-foreground">
          <img
            src={askmeLogo}
            alt={copy.app.title}
            className="mx-auto h-8 w-auto"
          />
          <h1 className="mt-5 text-[16px] font-semibold text-brand-paper-title">
            {copy.login.title}
          </h1>
          <p className="mx-auto mt-1 text-[14px] text-brand-paper-muted">
            {copy.login.subtitle}
          </p>
          <Button onClick={onSignIn} className="mt-6 w-full bg-header text-header-foreground text-[12px] hover:bg-header/90">
            {copy.login.signIn}
          </Button>
        </div>
      </div>
      <p className="mt-6 text-xs text-brand-paper-foreground">
        {copy.login.footer}
      </p>
    </div>
  )
}
